import { createContext, useContext } from 'react';
import { LearningPathStepID } from 'domains/learning-path/steps';
import { TypeLearningPathsFields } from 'types/contentful/clinical';
import { UseCompletableWizardResult } from 'utils/hooks/useCompletableWizard';

type LearningPathContext = {
  learningPath: TypeLearningPathsFields;
  onComplete: () => void;
} & UseCompletableWizardResult;

export const LearningPathCtx = createContext({} as LearningPathContext);

export const withLearningPathContext = (Component: React.FC, matchingStep: LearningPathStepID) => {
  return (props: Record<string, unknown>) => {
    const { currentStep } = useContext(LearningPathCtx);

    if (matchingStep === currentStep) {
      return <Component {...props} />;
    }

    return null;
  };
};
